import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { b2bServices } from '@services';
import { getCleanedUrlParams, showError } from '@utils';
import { LIMIT } from '@constants';
import { QUERY_KEYS } from 'constants/queryKeys';
import { useAssignees } from 'hooks/common';
import { normalizeOrders } from './utils';

export const B2B_ORDERS_PAGE_SIZE = LIMIT;

export const useB2BOrdersOperations = (enableFetch = true) => {
  const router = useRouter();
  const { assignees, assigneesMap } = useAssignees();

  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || B2B_ORDERS_PAGE_SIZE;
  const order = router.query?.order || 'desc';
  const orderBy = router.query?.orderBy || 'createdAt';

  const ordersResponse = useQuery(
    [QUERY_KEYS.GET_B2B_ORDERS_KEY, { orderBy, order, page, pageSize }],
    () =>
      b2bServices.getB2BOrders(
        getCleanedUrlParams({
          orderBy,
          order,
          page,
          pageSize: parseInt(pageSize, 10) || B2B_ORDERS_PAGE_SIZE,
        })
      ),
    { enabled: enableFetch, refetchOnMount: true }
  );

  const orders = normalizeOrders(ordersResponse?.data?.data || []);

  useEffect(() => {
    if (ordersResponse.isError) {
      showError(ordersResponse?.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordersResponse.isError]);

  return {
    page,
    pageSize: parseInt(pageSize, 10) || B2B_ORDERS_PAGE_SIZE,
    total: ordersResponse?.data?.meta?.total,
    loading: ordersResponse?.isLoading,
    orders,
    assignees,
    assigneesMap,
    refetch: ordersResponse.refetch,
  };
};
